export default "__VITE_ASSET__D0KQWE01__"